module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer001"
    }
  }, [_c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Travel makes you speechless, ")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("then it turns you into a storyteller. ")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body- ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("—Ibn Battuta,")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body- ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("fourteenth-century")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body- ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Moroccan traveler")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6dfb0078","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FranklinAve-1b.vue
// module id = 72
// module chunks = 0